
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M13.502 8.865V5.497a1.33 1.33 0 0 0-.667-1.153L8.169 1.677a1.33 1.33 0 0 0-1.334 0L2.17 4.344a1.33 1.33 0 0 0-.667 1.153v5.333a1.33 1.33 0 0 0 .667 1.153l4.666 2.667a1.33 1.33 0 0 0 1.334 0"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M7.477 9.656a2.157 2.157 0 1 0 0-4.313 2.157 2.157 0 0 0 0 4.313Z"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M4.089 12.723a3.55 3.55 0 0 1 5.576-2.408M14.734 11.869h.385a.3.3 0 0 1 .303.295v2.978a.3.3 0 0 1-.303.295h-4.39a.3.3 0 0 1-.302-.295v-2.978a.3.3 0 0 1 .302-.295h.434m1.333.357c-.158 0-.285-.12-.285-.268v-.535c0-.148.127-.268.285-.268h.856c.158 0 .286.12.286.268v.535c0 .148-.128.268-.286.268zM13.144 13.503h.833M11.863 13.467v.587"}})])
          )
        }
      }
    